<template>
    <div>
        <div class="item_detail_wrap item_detail_price_wrap">

            <div class="item_detail_top">
                <item-detail-main-slide-layout :item-data="itemData"></item-detail-main-slide-layout>
            </div>

            <div class="item_detail_middle">
                <div class="detail_middle_header">

                    <div class="thumbnail_wrap">
                        <ul @click="openModal('popup-modal',itemData)">
                            <li><img :src="returnItemProfile(itemData,'originator')" alt=""></li>
                            <li><img :src="returnItemProfile(itemData,'provider')" alt=""></li>
                            <li><img :src="returnItemProfile(itemData,'curator')" v-if="checkCurator(itemData)" alt="">
                            </li>
                        </ul>
                        <div class="time_wrap" v-if="itemData.i_status === 'auction'">
                            <div class="time_remain">{{ returnItemType(itemData) }}</div>
                        </div>
                    </div>

                    <div class="subject_wrap">
                        <h3>{{ returnCategoryName(itemData) }}</h3>
                        <p>{{ itemData.i_name }}</p>
                        <span v-if="itemData.im_edition === 1">{{ $t('edition') }} {{
                                itemData.im_count
                            }} / {{ itemData.im_total }}</span>
                    </div>

                    <div class="hashtag_wrap">
                        <ul>
                            <li v-for="(hash,index) in itemData.Hash" :key="`hash${index}`">
                                <span v-if="hash.ih_type === 1">#{{ hash.ic_name }}</span>
                                <span v-else>#{{ hash.ih_hashtag }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="detail_middle_content">
                    <ul>
                        <li class="min_bid_wrap">
                            <h3 class="regular">{{ $t('n_buy') }}</h3>
                            <div class="amount_wrap">
                                <div class="mg_icon"></div>
                                <div class="amount">{{ returnPrice() }}</div>
                                <div class="mg">Mg</div>
                                <div class="item_small">({{ returnMingle(itemData.i_price) }})</div>
                            </div>
                        </li>

                        <li class="max_bid_wrap">
                            <h3 class="regular tax_text" v-if="itemData.ibp_is_change  === 0"
                                @click="openModal('terms-modal', 'fees')">{{
                                    $t('f_tax')
                                }}</h3>
                            <h3 class="regular tax_text" v-else @click="openModal('terms-modal', 'fees')">{{
                                    $t('tax')
                                }}</h3>

                            <div class="amount_wrap">
                                <div class="mg_icon"></div>
                                <div class="amount">{{ setFeesData(itemData.i_price) }}</div>
                                <div class="mg">Mg</div>
                                <div class="item_small">({{ returnMingle(fees) }})</div>
                            </div>
                        </li>

                        <li class="buy_now_wrap">
                            <h3 class="regular">{{ $t('f_amount') }}</h3>
                            <div class="amount_wrap">
                                <div class="mg_icon"></div>
                                <div class="amount">{{ returnTotalPrice() }}</div>
                                <div class="mg">Mg</div>
                                <div class="item_small">({{ returnMingle(returnTotalPrice()) }})</div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="check_wrap mb20 mt30">
                    <el-checkbox v-model="termsCheck" @click="changeTerms">
                                            <span class="item_text_span bold"
                                                  @click="openModal('terms-modal', 'itembuy')">{{
                                                    $t('buy_item_terms')
                                                }}</span>
                        <span v-html="$t('agree_terms2')"></span>
                    </el-checkbox>

                </div>

                <div class="detail_middle_footer" v-if="checkMemberType()">
                    <div class="two_btn history_btn" @click="backEvent">{{ $t('cancel') }}</div>
                    <div class="two_btn bid_btn" @click="checkValidator">{{ $t('buy') }}</div>
                </div>
                <div class="detail_middle_footer" v-else>
                    <div class="one_btn history_btn" @click="backEvent">{{ $t('cancel') }}</div>
                </div>
                <div class="caption_check">
                    <div class="mt10 val_cap" v-if="termsMsgType"><p>{{ $t('caption_check') }}</p></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";
import imageOption from "@/mixins/imageOption";
import dateMixins from "@/mixins/dateMixins"
import priceMixins from "@/mixins/priceMixins";
import AuthMixins from "@/mixins/AuthMixins";
import imageResizeMixins from "@/mixins/imageResizeMixins";
import ItemDetailMainSlideLayout from "@/template/item/detail/ItemDetailMainSlideLayout";

export default {
    name: "ItemDetailPriceLayout",
    mixins: [imageOption, dateMixins, AuthMixins, priceMixins, imageResizeMixins],
    components: {
        ItemDetailMainSlideLayout,
        Swiper,
        SwiperSlide,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        itemData: {},
    },
    data() {
        return {
            itemCategorys: {},
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 8,
                grabCursor: true,
                autoWidth: true,
            },
            memberData: {},
            price: '',
            fees: '',
            termsCheck: false,
            termsMsgType: false,
            mainImg: ''

        }
    },
    beforeRouterEnter() {

    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            itemCategoryList: state => state.itemCategory.itemCategoryList,
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        setItemData() {
            if (!util.isEmpty(this.itemData) && !util.isEmpty(this.itemData.ItemFile) && !util.isEmpty(this.itemData.ItemFile.Detail)) {
                this.thumnailImgs = this.itemData.ItemFile.Detail;
                this.orgItemImg = this.itemData.ItemFile.Item[0].org_url;
                this.mainImg = this.orgItemImg;
                this.thumnailStatus = true;
            } else {
                this.thumnailImgs = [];
                this.mainImg = '';
                this.thumnailStatus = false;
            }

        },
        openModal(data, type) {
            this.$modal.show(`${data}`, {termsType: type});
        },
        openProfile(name, data) {
            this.$modal.show(`${name}`, {itemData: data});
        },
        returnItemProfile(data, type) {
            if (!util.isEmpty(data.profile) && !util.isEmpty(data.profile[type])) {
                return `${data.profile[type][0].org_url}?${this.setImageOptions(45, 45, 'png')}`;
            }
        },
        checkCurator(data) {
            if (!util.isEmpty(data.profile) && !util.isEmpty(data.profile.curator)) {
                return true
            }
            return false;
        },

        replaceBr(content) {
            if (util.isEmpty(content)) {
                return '';
            }
            return content.replace(/(\n|\r\n)/g, '<br>');
        },
        decodeHtml(html = '') {
            return util.htmlDecode(html);
        },
        checkCerti() {
            return !util.isEmpty(this.itemData) && !util.isEmpty(this.itemData.ItemFile) && !util.isEmpty(this.itemData.ItemFile.Guaranty) && !util.isEmpty(this.itemData.ItemFile.Guaranty[0].a_idx)
        },
        checkDetail() {
            return !util.isEmpty(this.itemData) && !util.isEmpty(this.itemData.ItemFile) && !util.isEmpty(this.itemData.ItemFile.Detail)
        },

        returnCategoryName(data) {
            if (data.ic_idx === 2) {
                return this.$t('art')
            } else if (data.ic_idx === 3) {
                return this.$t('picture')
            } else if (data.ic_idx === 4) {
                return this.$t('video')
            } else if (data.ic_idx === 5) {
                return this.$t('music')
            } else if (data.ic_idx === 9) {
                return this.$t('collections')
            }else if(data.ic_idx === 178){
                return this.$t('prompt')
            }
        },

        changeTerms() {
            this.termsCheck = !this.termsCheck;
        },
        getMemberData(data, type) {
            this.memberData = {}
            if (util.isEmpty(data[type])) {
                return
            }
            let params = {
                no: data[type]
            }
            this.$api.$member.getProfile(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 || util.isEmpty(res.List)) {
                    this.createAlert({
                        content: this.$t('detect_detail_empty'),
                        hide: () => {
                            this.$router.back();
                        }
                    })
                    return false;
                }
                this.memberData = res.List[0];
                this.$forceUpdate()
            })

        },
        returnMemberImg() {
            if (!util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files.Profile)) {
                return `${this.memberData.Files.Profile[0].org_url}?${this.setImageOptions(62, 62, 'png')}`
            }
        },
        checkMemberData() {
            return !util.isEmpty(this.memberData)
        },
        moveMember(url) {
            this.$router.push(`/${url}`)
        },
        checkMemberType() {
            if (!util.isEmpty(this.UserInfo) && this.itemData.provider === this.UserInfo.mb_no || this.UserInfo.g_idx === 2) {
                return false
            }
            return true
        },
        checkValidator() {
            if (!this.termsCheck) {
                this.termsMsgType = true;
                return;
            } else {
                this.termsMsgType = false;
            }
            if (!this.isLogin()) {
                this.createConfirm({
                    content: this.$t('not_login_confirm'),
                    confirmText: this.$t('go_login'),
                    confirm: () => {
                        this.$router.push('/auth');
                    }
                })
                return false;
            } else {
                this.buyItem('pricetag', this.itemData.i_price)
            }

        },
        buyItem(type, price) {
            EventBus.$emit('buyItem', type, price);
        },
        setFeesData(price) {
            price = this.returnMaxPrice(price);
            this.fees = this.setFees(this.itemData, price);

            return util.Number.numFormat(this.fees);
        },
        setData(key, value) {
            this[key] = value;
        },
        returnTotalPrice() {
            let total = 0;
            let price = this.returnNumber(this.itemData.i_price)
            total = price + Number(this.fees);
            return util.Number.numFormat(total);
        },
        returnPrice() {
            if (!util.isEmpty(this.itemData)) {
                return util.Number.numFormat(this.itemData.i_price);
            }
        },
        backEvent() {
            this.$router.back();
        },
        slideChange() {
            this.slideIndex = this.$refs.swiper.$swiper.realIndex;
        },
        onClick(event) {
            if (util.isEmpty(event.target)) {
                return false;
            }
            let element = event.target;
            let elementSrc = element.currentSrc.split('?');

            if (util.isEmpty(elementSrc[0])) {
                return false;
            }
            this.changeThumnail(elementSrc[0]);
        },
    },
    watch: {
        "itemData": {
            deep: true,
            handler: function (val, oldVal) {
                this.setItemData();
            }
        },
    },
}
</script>

<style scoped>

</style>

